module.exports = __webpack_public_path__ + "33b9031094452ee2e4dd5aec2a5e1b7c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Sectra-Fine-Book.ttf
// module id = 46
// module chunks = 0